import moment from "moment-timezone";
import {
  DEFAULT_COMPANY_TIMEZONE,
  companyLocalDateTimeToUtcIso,
  getStoredCompanyTimezone,
  resolveCompanyTimezone,
  toCompanyInputDateTime
} from "./companyTimezone";

export const getUserTimezone = () => {
  try {
    const storedTimezone = getStoredCompanyTimezone();
    if (storedTimezone) return storedTimezone;
    const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone || DEFAULT_COMPANY_TIMEZONE;
    return resolveCompanyTimezone(timezone);
  } catch (_) {
    return DEFAULT_COMPANY_TIMEZONE;
  }
};

export const formatDateTimeForUser = (utcDate, format = "DD/MM/YYYY HH:mm", timezone) => {
  if (!utcDate) return "—";
  try {
    const tz = timezone || getUserTimezone();
    const parsed = moment.utc(utcDate);
    if (!parsed.isValid()) return "—";
    return parsed.tz(tz).format(format);
  } catch (error) {
    console.error("[formatDateTimeForUser]", error, utcDate);
    return "—";
  }
};

export const toUserInputDateTime = (utcDate, timezone) => {
  return toCompanyInputDateTime(utcDate, timezone || getUserTimezone());
};

export const buildDateTimePayload = (localDateTime, timezone) => {
  const tz = timezone || getUserTimezone();
  const utcDateTime = companyLocalDateTimeToUtcIso(localDateTime, tz);
  return {
    localDateTime,
    timezone: tz,
    utcDateTime
  };
};

export const safeFormatDateTimeForUser = (value, fallback = "—") => {
  if (!value) return fallback;
  try {
    const timezone = getUserTimezone();
    const date = value instanceof Date ? value : new Date(value);
    if (Number.isNaN(date.getTime())) return fallback;
    return new Intl.DateTimeFormat("pt-BR", {
      timeZone: timezone,
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit"
    }).format(date);
  } catch (error) {
    console.error("[safeFormatDateTimeForUser]", error, value);
    return fallback;
  }
};
